import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ReviewServices from './review_services';

export const CreateReview = createAsyncThunk(
  'review/create_review',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReviewServices.CreateReview(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadReviewImage = createAsyncThunk(
  'review/review_image',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReviewServices.uploadReviewImage(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadReviewIcon = createAsyncThunk(
  'review/review_icon',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReviewServices.uploadReviewIcon(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllReview = createAsyncThunk(
  'review/get_all_review',
  async (payload, thunkAPI) => {
    try {
      let response = await ReviewServices.getAllReview(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllMajorReview = createAsyncThunk(
  'review/get_all_major_review',
  async (payload, thunkAPI) => {
    try {
      let response = await ReviewServices.getAllMajorReview();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteReview = createAsyncThunk(
  'review/delete_review',
  async (payload, thunkAPI) => {
    try {
      let response = await ReviewServices.DeleteReview(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleReviewDetails = createAsyncThunk(
  'review/get_single_review',
  async (payload, thunkAPI) => {
    try {
      let response = await ReviewServices.getSingleReviewDetails(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditReviewDetail = createAsyncThunk(
  'review/edit_review',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReviewServices.EditReview(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const SearchForReviewsByName = createAsyncThunk(
  'review/searchForReviewsByName',
  async (payload, thunkAPI) => {
    try {
      const delivered = await ReviewServices.SearchForReviewByName(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
